import { Controller } from "@hotwired/stimulus"

// Rows picked in a table: the page checkbox picks or clears them all, the
// bar over the table counts them and its Export link carries their ids.
export default class extends Controller {
  static targets = ["all", "item", "bar", "count", "export"]
  static values = { export: String }

  toggleAll() {
    this.itemTargets.forEach((item) => { item.checked = this.allTarget.checked })
    this.update()
  }

  clear() {
    this.itemTargets.forEach((item) => { item.checked = false })
    this.update()
  }

  update() {
    const picked = this.itemTargets.filter((item) => item.checked)

    this.itemTargets.forEach((item) => item.closest("tr")?.classList.toggle("sel", item.checked))
    const total = this.itemTargets.length

    this.allTarget.checked = picked.length > 0 && picked.length === total
    this.allTarget.indeterminate = picked.length > 0 && picked.length < total
    this.barTarget.hidden = picked.length === 0
    this.countTarget.textContent = this.barTarget.dataset.countLabel?.replace("%{count}", picked.length) ?? picked.length

    const url = new URL(this.exportValue, window.location.origin)

    url.searchParams.delete("ids[]")
    picked.forEach((item) => url.searchParams.append("ids[]", item.value))

    this.exportTarget.href = url.pathname + url.search
  }
}
